import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const FadeIn = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    className={`fade-in ${className}`}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ no, kicker, title, id }) => (
  <div id={id} data-testid={`chapter-${no}`} className="border-t-2 border-ink px-4 sm:px-8 pt-16 pb-10 scroll-mt-14">
    <FadeIn className="flex flex-col lg:flex-row lg:items-end gap-4 lg:gap-10">
      <span className="font-serif text-outline leading-none text-7xl sm:text-8xl lg:text-9xl select-none">{no}</span>
      <div className="pb-2">
        <p className="font-mono text-[10px] sm:text-xs tracking-[0.24em] uppercase text-salsa mb-3">{kicker}</p>
        <h2 className="font-serif font-semibold tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl">
          {title}
        </h2>
      </div>
    </FadeIn>
  </div>
);

export default Chapter;
